<template>
  <footer class="bg-ternary relative text-button-border">
    <div class="leading-loose texto-roboto mx-auto md:text-center px-6 md:px-40 md text-xl md:text-4xl line160">
      This website will inform you with our progress on supporting children in a crucial period of their lives, and hopefully will engage you to either participate in our effort or like us, setup a foundation and start making a change.
    </div>
    <div class="container mx-auto flex flex-col px-10 md:px-6 xl:px-40 object-contain h-auto md:flex-row justify-center pt-16 md:pt-32 md:text-5xl">
      <img class="mx-auto lg:ml-6 max-w-full md:max-w-sm xl:max-w-xl h-auto" src="../../assets/images/footer/footer-image.jpg" alt />
      <div class="title text-white leading-relaxed w-full text-center md:text-left lg:text-center">
        <p
          class="texto-roboto pt-6 md:pt-0 text-center text-4xl md:text-5xl uppercase font-bold text-white line120 font-bold"
        >thanks for visiting</p>
        <p class="texto-caveat text-center text-4xl md:text-5xl text-cream mb-6 line100">GoldenRace Foundation</p>
      </div>
    </div>

    <div class="flex w-full justify-end">
      <div class="right uppercase text-primary texto-roboto">
        <img class src="../../assets/images/footer/footer-image2.png" alt />
      </div>
    </div>
    <div class="footer-bar leading-relaxed px-6 md:px-12 pb-10 texto-roboto flex flex-col-reverse md:flex-row md:justify-between absolute bottom-0 z-20 text-white w-full ">
      <div class="w-full pt-10 md:pt-0 text-right md:text-left text-base texto-roboto text-primary md:text-white">
        <p>&copy; <span class="font-bold">{{ date }} GoldenRace</span></p>
        <p class="text-right md:text-left w-full">All rights reserved</p>
      </div>
      <div class="text-primary font-bold uppercase flex flex-col text-right whitespace-no-wrap text-xl md:text-2xl">
        <router-link to="/privacy">Privacy Policy</router-link>
        <router-link to="/terms">Terms of Service</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear()
    }
  },

};
</script>